import baseStyles from '../Base/Base.styles'
import merge from 'lodash/merge'
import percent from '@converdy/utils/percent'
import { parseResponsiveProperty } from '@converdy/styles'
import {media} from '@converdy/styles/breakpoints'

export default ({ base, color, minStock, maxStock }) => {
  const jss =  {
    root: {
      ...baseStyles(base),
      padding: '32px',
      fontWeight: 'normal',

      '& .text': { marginBottom: '8px' },

      '& .stock-number': parseResponsiveProperty('color', color),

      '& .bar': {
        width: '100%',
        background: 'var(--color-greyDefault)',
        height: '8px',
        borderRadius: '4px'
      },
      
      '& .stock-bar': {
        ...parseResponsiveProperty('background', color),
        display: 'block',
        height: '100%',
        borderRadius: '4px',
        width: `${percent(maxStock, minStock)}%`,

      }
    }
  }

  return jss
}
